import React, { useContext, useEffect, useRef, useState } from 'react';
import { ApiContext } from '@api/api';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { LovWithoutIdDTO } from '@api/ringil-api.v2';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  value: string;
  onChange: (cloCode: string) => void;
  disabled?: boolean;
  dataTestId?: string;
  // Opt-in: when the caller already has the LOV, pass it to avoid a duplicate fetch.
  options?: LovWithoutIdDTO[];
}

export const CustomsTypeComponent: React.FC<ComponentProps> = ({ value, onChange, disabled = false, dataTestId, options }) => {
  const { lovCustomsTypes } = useContext(ApiContext);
  const [fetched, setFetched] = useState<LovWithoutIdDTO[]>([]);
  const customsTypes = options ?? fetched;
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (options) return; // caller supplied options → skip the BE call
    lovCustomsTypes(d => {
      setFetched(d);
    });
  }, [options]);

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-dropdown', dataTestId);
  }, [customsTypes, dataTestId]);

  return (
    <div ref={wrapperRef}>
      <Dropdown
        options={customsTypes}
        optionValue={'code'}
        optionLabel={'name'}
        value={value}
        style={{ width: '100%' }}
        disabled={disabled}
        onChange={e => onChange(e.value)}
        itemTemplate={(option: LovWithoutIdDTO) => (
          <span data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option?.name || option?.code || '')}` : undefined}>{option?.name}</span>
        )}
      />
    </div>
  );
};
